import React, { useEffect, useState } from 'react';
import { scroller } from 'react-scroll';
import { resetButtonStyle } from '@kvdbil/components';
import styled from 'styled-components';

const PageMenu = styled.ul``;
const PageMenuItem = styled.li`
  text-align: left;
  font-size: 1.2rem;
  margin: 1.4rem 0;

  :hover {
    color: ${({ theme }) => theme.colors.text.disabled};
  }
`;

interface Props {
  items: {
    id: string;
    text: string;
    isDisabled?: boolean;
  }[];
  offset?: number;
}

const Button = styled.button<{ isActive: boolean; isDisabled: boolean }>`
  ${resetButtonStyle};
  text-align: left;
  cursor: pointer;

  :hover {
    color: ${({ theme }) => theme.colors.primary.dark};
  }

  ${({ isActive, theme }) =>
    isActive &&
    `
      color: ${theme.colors.primary.main};
      font-weight: ${theme.typography.fontBaseBoldWeight};
    `};

  ${({ isDisabled, theme }) =>
    isDisabled &&
    `
      color: ${theme.colors.text.disabled};
      cursor: default;

      :hover {
        color: ${theme.colors.text.disabled};
      }
    `};
`;

const ScrollTo = ({ items, offset }: Props) => {
  const [activeId, setActiveId] = useState('');

  useEffect(() => {
    scroller.scrollTo(activeId, {
      duration: 250,
      smooth: true,
      offset: offset ?? -90
    });
  }, [activeId, offset]);

  return (
    <PageMenu>
      {items.map(item => {
        return (
          <PageMenuItem key={item.id} data-testid={item.id}>
            <Button
              isDisabled={item.isDisabled ?? false}
              isActive={activeId === item.id}
              onClick={() => !item.isDisabled && setActiveId(item.id)}
            >
              {item.text}
            </Button>
          </PageMenuItem>
        );
      })}
    </PageMenu>
  );
};

export default ScrollTo;
